export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'fas fa-tachometer'
    },{
      name: 'Articles',
      url: '/articles/list',
      icon: 'fas fa-bookmark'
    },{
      name: 'Services',
      url: '/services/list',
      icon: 'fas fa-user-astronaut'
    },{
      name: 'Doctors',
      url: '/doctors/list',
      icon: 'fas fa-user-md'
    },{
      name: 'Languages',
      url: '/languages/list',
      icon: 'far fa-language'
    },{
      name: 'Promotions',
      url: '/promotions/list',
      icon: 'fab fa-product-hunt'
    },{
      name: 'Reviews',
      url: '/reviews/list',
      icon: 'far fa-comment-alt-lines'
    },{
      name: 'Settings',
      url: '/settings',
      icon: 'fas fa-cog'
    },{
      name: 'Gallery',
      url: '/gallery',
      icon: 'fas fa-images'
    },{
      title: true,
      name: 'Profile',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },{
      name: 'Logout',
      url: '/logout',
      icon: 'fas fa-sign-out-alt'
    }
  ]
}
